module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.f5331cb6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/PDFReport/fonts/OpenSans-Bold.ttf
// module id = 1171
// module chunks = 0